<form nz-form [formGroup]="input.form" class="compose-notification-form">
	<!-- Type Selector -->
	<nz-form-item>
		<nz-form-label [nzSpan]="2" nzRequired>Type</nz-form-label>
		<nz-form-control [nzSpan]="22">
			<nz-select formControlName="type" nzPlaceHolder="Select type">
				<nz-option nzValue="Email" nzLabel="Email"></nz-option>
				<nz-option nzValue="Sms" nzLabel="SMS"></nz-option>
			</nz-select>
		</nz-form-control>
	</nz-form-item>
	<!-- Email fields -->
	<ng-container *ngIf="input.form.get('type')?.value === 'Email'">
		<!-- From (readonly) -->
		<nz-form-item>
			<nz-form-label [nzSpan]="2">From</nz-form-label>
			<nz-form-control [nzSpan]="22">
				<input nz-input [value]="input.payload.emailFrom" readonly />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label nzRequired [nzSpan]="2">To</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Invalid email(s) or placeholder(s)'">
				<input nz-input formControlName="emailTo">
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2">Cc</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Invalid email(s) or placeholder(s)'">
				<input nz-input formControlName="emailCc" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2">Bcc</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Invalid email(s) or placeholder(s)'">
				<input nz-input formControlName="emailBcc" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>Subject</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Subject is required'">
				<input nz-input formControlName="emailSubject" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item *ngIf="input.form.get('emailBody')">
			<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Body is required'">
				<app-email-body-editor formControlName="emailBody" [placeholders]="placeholders">
				</app-email-body-editor>
			</nz-form-control>
		</nz-form-item>
	</ng-container>
	<!-- SMS fields -->
	<ng-container *ngIf="input.form.get('type')?.value === 'Sms'">
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>To</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Invalid MSISDN(s) or placeholder(s)'">
				<input nz-input formControlName="smsMsisdn" />
			</nz-form-control>
		</nz-form-item>
		<nz-form-item>
			<nz-form-label [nzSpan]="2" nzRequired>Body</nz-form-label>
			<nz-form-control [nzSpan]="22" [nzErrorTip]="'Body is required'">
				<app-email-body-editor formControlName="smsMessage" [placeholders]="placeholders">
				</app-email-body-editor>
			</nz-form-control>
		</nz-form-item>
	</ng-container>
	<!-- Attachments -->
	<nz-form-item>
		<nz-form-label [nzSpan]="2">
			Attachments
		</nz-form-label>
		<nz-form-control [nzSpan]="22">
			<nz-upload [nzMultiple]="true" [nzCustomRequest]="customUpload" [nzShowUploadList]="false">
				<button nz-button>
					<i nz-icon nzType="upload"></i>
					Upload file
				</button>
			</nz-upload>
			<div formArrayName="attachments" class="mt-2">
				<nz-list>
					<nz-list-item *ngFor="let ctrl of allAttachments; let i = index" [formGroupName]="i">
						<label nz-checkbox formControlName="selected">
							{{ ctrl.get('fileName')?.value }}
						</label>
					</nz-list-item>
				</nz-list>
			</div>
		</nz-form-control>
	</nz-form-item>
	<div class="compose-notification-actions" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;" *ngIf="showActions">
		<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
		<button nz-button nzType="primary" [disabled]="input.form.invalid" (click)="onSend()">Send</button>
	</div>
</form>
